/**
 * Determines cloudinary switch status
 * @return {boolean} switch status
 */
export function isCloudinaryEnabled(): boolean {
    return process.env.CLOUDINARY_ENABLED === '1';
}

const EXCLUDE_LIST: Array<string | RegExp> = [/\.*exclude=1/];

/**
 * Is exclude url
 * @param {string} url - url
 * @return {boolean} is exclude url?
 */
export const isExcludeUrl = (url: string): boolean => EXCLUDE_LIST.some(e => url.match(e));

/**
 * Get cloudinary prefix
 * @param {string} tag - tag
 * @param {boolean} svg - is svg
 * @return {string} prefix
 */
export function getCloudinaryPrefix(tag = '', svg = false): string {
    const defaultTag =
        (svg ? process.env.SVG_CLOUDINARY_TAG : process.env.DEFAULT_CLOUDINARY_TAG) || '';

    return isCloudinaryEnabled() ? `${process.env.CLOUDINARY_URL}/${tag || defaultTag}` : '';
}

/**
 * Get url with prefix cloudinary or source url if url contain in EXCLUDE_LIST
 * @param {string} url - url
 * @param {string} tag - tag
 * @param {boolean} svg - is svg
 * @return {string} prefix
 */
export function getCloudinaryURL(url: string, tag = '', svg = false): string {
    const prefix = isExcludeUrl(url) ? '' : getCloudinaryPrefix(tag, svg);

    return `${prefix}${url
        .replace(`${process.env.CLOUDINARY_URL}/${process.env.DEFAULT_CLOUDINARY_TAG}`, '')
        .replace(`${process.env.CLOUDINARY_URL}/${process.env.SVG_CLOUDINARY_TAG}`, '')
        .replace('?exclude=1', '')}`;
}
